module.exports = __webpack_public_path__ + "img/discover.c4db2a79.svg";